module.exports = __webpack_public_path__ + "img/custom_bg1.a7182d67.png";